<template>
  <section class="table-sampler-classification-noise">
    <d-form-row class="mb-1">
      <d-col cols="3">
        <label>Condição de exposição</label>
        <select type="text" class="form-control" v-model="model.condition" required>
          <option value="Obedecidos os limites estabelecidos na Tabela 1">Obedecidos os limites estabelecidos na Tabela 1</option>
          <option value="Acima dos limites estabelecidos na Tabela 1 até os limites inferiores da região de incerteza estabelecidos na Tabela 4">Acima dos limites estabelecidos na Tabela 1 até os limites inferiores da região de incerteza estabelecidos na Tabela 4</option>
          <option value="No intervalo de valores estabelecidos na Tabela 4">No intervalo de valores estabelecidos na Tabela 4</option>
          <option value="Acima dos limites estabelecidos na Tabela 2">Acima dos limites estabelecidos na Tabela 2</option>
        </select>
      </d-col>
      <d-col cols="3">
        <label>Consideração técnica</label>
        <select type="text" class="form-control" v-model="model.consideration" required>
          <option value="Aceitável">Aceitável</option>
          <option value="Acima do nível de ação">Acima do nível de ação</option>
          <option value="Região de incerteza">Região de incerteza</option>
          <option value="Acima do limite de exposição">Acima do limite de exposição</option>
        </select>
      </d-col>
      <d-col cols="auto">
        <label>Atuação recomendada</label>
        <select type="text" class="form-control" v-model="model.exposition_recomendation" required>
          <option value="No mínimo, manutenção da condição existente">No mínimo, manutenção da condição existente</option>
          <option value="No mínimo, adoção de medidas preventivas">No mínimo, adoção de medidas preventivas</option>
          <option value="Adoção de medidas preventivas e corretivas visando à redução da exposição">Adoção de medidas preventivas e corretivas visando à redução da exposição</option>
          <option value=">Adoção imediata de medidas corretivas">Adoção imediata de medidas corretivas</option>
        </select>
      </d-col>
    </d-form-row>
    <d-form-row class="mb-1">
      <d-col cols="12">
        <label>Recomendação da exposição</label>
        <textarea
          type="text"
          class="form-control"
          v-model="model.recomendation"
          required
        ></textarea>
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { NOISE_CLASSIFICATION, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Classification-Noise',
  props: {
    classification: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(NOISE_CLASSIFICATION),
    };
  },
  methods: {
    setModel() {
      if (this.classification) {
        this.model = this.classification;
      }
    },
  },
  mounted() {
    this.setModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:classification', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
